import { GigsListing } from '../../components/GigsListing';
import { withAfp1Observer } from './withAfp1Observer';

export const WidgetComponent = withAfp1Observer(GigsListing);
